import { IRollSelectBehavior } from "../../../../../../../documaker/domain/format/objects";
import { IRollObjectBean } from "../../../beans/objects";
import { ItemsTranslator } from "./ItemsTranslator";
import { IntegerTranslator, ColorCodeTranslator } from "../../values";

export class RollSelectBehaviorTranslator {
  from(bean: IRollObjectBean): IRollSelectBehavior {
    return {
      options: this.items.from(
        bean.rollitem,
        s => {
          return {
            text: s["@text"],
            isSelected: (s["@selected"] === "1"),
            score: this.integer.from(s["@score"]),
            style: {
              foreground: {
                color: {
                  value: this.colorCode.from(s["@fg"]),
                },
              },
              background: {
                isEnable: (s["@bg"] !== undefined) && (s["@bg"] !== null),
                color: {
                  value: this.colorCode.from(s["@bg"]),
                },
              },
            },
          };
        },
      ),
    };
  }

  to(object: IRollSelectBehavior) {
    return {
      rollitem: this.items.to(
        object.options,
        s => ({
          "@name": s.text,
          "@text": s.text,
          "@fg": this.colorCode.to(s.style.foreground.color.value),
          "@bg": s.style.background.isEnable ? this.colorCode.to(s.style.background.color.value) : undefined, // nullの場合は出力しない
          "@score": this.integer.to(s.score),
          "@selected": s.isSelected ? "1" : undefined,  // 初回未入力時は出力しない
        })
      ),
    };
  }

  private readonly items = new ItemsTranslator();
  private readonly integer = new IntegerTranslator();
  private readonly colorCode = new ColorCodeTranslator();
}
